import React, { FC } from 'react';
import { TextInput as RNTextInput, TextInputProps } from 'react-native';
// import { textInputStyles } from './TextInput.styles';

export const TextInput: FC<TextInputProps> = ({ style, ...props }) => (
  <RNTextInput style={[style]} {...props} />
);
